import { Box, ListItemIcon, Typography } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import styled from '@emotion/styled';
import { trpc } from 'src/utils/trpc';
import * as Icons from '@mui/icons-material';

const IconList = Icons as {
  [key: string]: SvgIconComponent;
};

const StyledFirstStepperItem = styled.li`
  position: relative;
  display: flex;
  gap: 1rem;
  padding-bottom: 1.5rem;
  align-items: center;
  &:before {
    content: '';
    flex: 0 0 47px;
    height: 35px;
    border-radius: 50%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  &:not(:last-child):after {
    content: '';
    position: absolute;
    top: 35px;
    bottom: 0px;
    transform: translateX(calc(45px / 2));
    width: 3px;
    background-color: #a3a1a6;
  }
`;

const StyledSecondStepperItem = styled.li`
  position: relative;
  display: flex;
  gap: 1rem;
  padding-bottom: 1.5rem;
  align-items: center;
  &:before {
    content: '';
    flex: 0 0 47px;
    height: 20px;
    border-radius: 50%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  &:not(:last-child):after {
    content: '';
    position: absolute;
    top: 26px;
    bottom: -1px;
    transform: translateX(calc(45px / 2));
    width: 3px;
    background-color: #a3a1a6;
  }
`;

const CarketaConnect = (vehicle: any) => {
  const { data: recon_workflow } =
    trpc.vehicle_recon.getConnectWorkflowRecon.useQuery(
      { vehicle_id: vehicle?.vehicle?.id },
      {
        refetchOnWindowFocus: true,
        keepPreviousData: false,
        enabled: !!vehicle,
      }
    );

  return (
    <>
      <Typography variant="h6" sx={{ mb: 5, color: '#000', mt: 5 }}>
        Carketa Connect
      </Typography>

      <div className="flex justify-between mb-4 flex-col">
        <p className="text-16 ">
          {vehicle?.vehicle?.year} {vehicle?.vehicle?.make}{' '}
          {vehicle?.vehicle?.model} {vehicle?.vehicle?.trim}
        </p>
      </div>
      <div className="flex">
        <p className="text-14 mr-4 ">VIN</p>
        <p className="text-14 gray-500">{vehicle?.vehicle?.vin}</p>
      </div>
      <div className="flex mb-10">
        <p className="text-14 mr-4 ">STOCK#</p>
        <p className="text-14 gray-500">{vehicle?.vehicle?.stock_number}</p>
      </div>

      <div className="p-2 w-full outline outline-1 outline-[#bdbdbd] rounded">
        <div className="py-2 px-4 ">
          <Typography
            variant="subtitle1"
            sx={{ mb: 5, color: '#000', mt: 5, ml: 2 }}
          >
            Recon Progress
          </Typography>
          <div className="stepper">
            <ol className="stepper__content">
              {recon_workflow?.map((step, index) => {
                const { id, status, title, icon } = step;
                const Icon = IconList[icon ?? 'InsertPhoto'];
                const CircleIcon = IconList['Circle'];
                if (status === 'Completed') {
                  return (
                    <StyledFirstStepperItem key={id}>
                      <ListItemIcon
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          position: 'absolute',
                          top: 0,
                          left: 6,
                          padding: '4px',
                          border: '1px solid',
                          borderRadius: '100%',
                        }}
                      >
                        <Box>{Icon && <Icon fontSize="medium" />}</Box>
                      </ListItemIcon>
                      <div>
                        <h3 className="stepper__title">{`Completed ${
                          title ?? 'Step ' + (index + 1)
                        }`}</h3>
                      </div>
                    </StyledFirstStepperItem>
                  );
                } else {
                  return (
                    <StyledSecondStepperItem key={id}>
                      <ListItemIcon
                        sx={{
                          color: (theme) => theme.palette.secondary.main,
                          position: 'absolute',
                          top: 0,
                          left: 14,
                        }}
                      >
                        <Box>
                          {CircleIcon && <CircleIcon fontSize="small" />}
                        </Box>
                      </ListItemIcon>
                      <div>
                        <h3 className="stepper__subtitle">{`Waiting ${
                          title ?? 'Step ' + (index + 1)
                        }`}</h3>
                      </div>
                    </StyledSecondStepperItem>
                  );
                }
              })}
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarketaConnect;
